// extracted by mini-css-extract-plugin
module.exports = {"table":"instructions-table_table__VkoQK","small":"instructions-table_small__Oxqfs"};